import dayjs from "dayjs";
import { ROUTES_PATH } from "../constants";
import { GTMTimeElapse } from "../interfaces/Analytics";

const AnalyticsHelper = {
  getTimeElapse: (timeData: GTMTimeElapse): number => {
    const duration = timeData.initTime.diff(timeData.finishTime, "second");
    return duration;
  },
  getStepLocation: (pathname: string) => {
    switch (pathname) {
      case ROUTES_PATH.ENTRY:
      case ROUTES_PATH.ENTRY_SUS:
      case ROUTES_PATH.CONTINUATION:
        return 1;
      case ROUTES_PATH.PERSONAL_DATA:
      case ROUTES_PATH.LABOR_DATA:
      case ROUTES_PATH.OCR:
      case ROUTES_PATH.OPERATION_SHIPPING:
      case ROUTES_PATH.PAYMENT:
      case ROUTES_PATH.EXISTING_PAYMENT:
      case ROUTES_PATH.PERSONAL_FINANCES:
        return 2;
      case ROUTES_PATH.SIGNATURE:
        return 3;
      case ROUTES_PATH.QUIT:
      case ROUTES_PATH.TIMEOUT:
      case ROUTES_PATH.UNPROCESSABLE:
      case ROUTES_PATH.END:
      case ROUTES_PATH.DENIAL:
      case ROUTES_PATH.UNKNOWN_ERROR:
      case ROUTES_PATH.EXISTING_RFN:
      default:
        return 0;
    }
  },
  getAgeRange: (birthDate: string): string | undefined => {
    const date1 = dayjs(birthDate);
    const date2 = dayjs();
    const age = date1.diff(date2, "year");

    let age_group = "75+";

    if (age <= 25) age_group = "18-25";
    else if (age <= 35) age_group = "26-35";
    else if (age <= 45) age_group = "36-45";
    else if (age <= 55) age_group = "46-55";
    else if (age <= 65) age_group = "56-65";
    else if (age <= 75) age_group = "66-75";

    if (age < 18) age_group = "<18";

    return age_group;
  },
};

export default AnalyticsHelper;
